<template>
  <div class="wj_box" style="background-color: #ecf3fe">
    <!-- #EFF3FA -->
    <el-row class="wj_main">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="wj_body" v-if="answerPaper.State === 1">
          <div class="wj_body_head">
            <h1>{{ answerPaper.QuestionnaireName }}</h1>
          </div>
          <div class="wj_body_head_secondary" v-if="answerPaper.WelcomeWord">
            {{ answerPaper.WelcomeWord }}
          </div>
          <div class="wj_body_head_info" style="margin-bottom: 10px">
            <div class="wj_body_head_info_left">
              <span
                class="wj_body_head_info_left_item"
                v-if="answerPaper.QuestionnaireType === 1"
              >
                题目数量：{{ answerPaper.QuestinsNumber }}
              </span>
              <span
                v-if="answerPaper.QuestionnaireType === 1"
                class="wj_body_head_info_left_item"
              >
                总分：{{ answerPaper.TotalScore }}分
              </span>
              <span
                v-if="
                  answerPaper.QuestionnaireType === 1 &&
                  answerPaper.IsSetPassScore
                "
                class="wj_body_head_info_left_item"
              >
                通过线：{{ answerPaper.PassScore }}分
              </span>
            </div>
            <div
              class="wj_body_head_info_right"
              v-if="answerPaper.QuestionnaireType === 1"
            >
              <span class="wj_body_head_info_right_item">
                开始时间：
                {{ answerPaper.StartTime | dateformat('YYYY-MM-DD HH:mm') }}
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.TimeState === 1"
              >
                未到开始时间
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.TimeState === 2"
              >
                <i
                  class="el-icon-timer"
                  style="font-size: 26px; margin-right: 5px"
                ></i>
                <FlipDown
                  :endDate="answerPaper.EndTime"
                  @timeUp="timeOut"
                  :type="3"
                  :theme="1"
                  :timeUnit="[':', ':', ':']"
                  class="flip-down"
                />
              </span>
              <span
                class="wj_body_head_info_right_item"
                v-if="answerPaper.TimeState === 3"
              >
                已过答题时间
              </span>
            </div>
          </div>
          <div
            class="wj_element_box"
            v-for="(element, index) in answerPaper.ElementItems"
            :key="index"
          >
            <div
              class="wj_element"
              :style="[
                {
                  border: element.NoAnswer
                    ? '2px solid #E6A23C'
                    : '2px solid #eff3fa'
                }
              ]"
            >
              <div
                class="wj_element_title_all wj_element_title_duanluo"
                v-if="element.ElementType === 1 && !element.IsOnlyManualShow"
              >
                <span class="show_index">{{ element.ShowIndex }}、</span>
                <div class="wj_element_title" v-html="element.Title"></div>
              </div>

              <div
                class="wj_element_title_all wj_element_title_question_16"
                v-if="element.ElementType === 2 && element.QuestionType !== 4"
              >
                <p
                  style="
                    font-size: 16px;
                    height: 36px;
                    line-height: 36px;
                    flex-shrink: 0;
                    margin: 0px 5px 0px 0px;
                  "
                >
                  {{ element.ShowIndex }}.
                </p>
                <!-- <span class="show_index">{{ element.ShowIndex }}.</span> -->
                <!-- <div
                  class="wj_element_title"
                  v-html="
                    '<span class=\'element_type\'>【' +
                    element.QuestionTypeText +
                    '】</span>' +
                    element.QuestionStem
                  "
                ></div> -->
                <div
                  class="wj_element_title"
                  v-html="element.QuestionStem"
                ></div>
              </div>

              <div
                class="wj_element_title_all wj_element_title_question_16"
                v-if="element.ElementType === 2 && element.QuestionType === 4"
                @click="blankFocus(element)"
              >
                <p
                  style="
                    font-size: 16px;
                    height: 36px;
                    line-height: 36px;
                    flex-shrink: 0;
                    margin: 0px 5px 0px 0px;
                  "
                >
                  {{ element.ShowIndex }}.
                </p>
                <!-- <span class="show_index" style="min-height: 36px">
                  {{ element.ShowIndex }}.
                </span> -->
                <div
                  class="wj_element_title"
                  v-html="getBlankBody(element, index)"
                ></div>
                <!-- <div class="wj_element_title">
                  <div
                    class="questionStem"
                    v-html="getBlankBody(element, index)"
                  ></div>
                  <span class="element_type" v-if="element.QuestionTypeText">
                    【{{ element.QuestionTypeText }}】
                  </span>
                  <span
                    class="element_score"
                    v-if="answerPaper.QuestionnaireType === 1"
                    v-show="false"
                  >
                    （{{ element.QuestionScore }}分）
                  </span>
                </div> -->
              </div>

              <div
                class="wj_element_option_box"
                v-if="element.QuestionType === 1 || element.QuestionType === 3"
              >
                <div
                  class="wj_element_option_item"
                  v-for="(optionItem, optionIndex) in element.OptionItems"
                  :key="optionIndex"
                >
                  <el-radio
                    v-model="element.SelectOptionId"
                    :label="optionItem.AnswerPaperOptionId"
                    class="choice"
                    :disabled="
                      element.SelectOptionId !==
                        optionItem.AnswerPaperOptionId &&
                      answerPaperState.IsSubmit
                    "
                    @change="optionRadioChange(element)"
                  >
                    <div class="choice_inner">
                      <span class="choice_index">{{
                        getOptionIndex(
                          answerPaper.OptionSerialNumberType,
                          optionIndex
                        )
                      }}</span>
                      <div
                        class="choice_content"
                        v-html="optionItem.Content"
                      ></div>
                    </div>
                  </el-radio>
                </div>
              </div>

              <div
                class="wj_element_option_box"
                v-if="element.QuestionType === 2"
              >
                <div
                  class="wj_element_option_item"
                  v-for="(optionItem, optionIndex) in element.OptionItems"
                  :key="optionIndex"
                >
                  <el-checkbox
                    v-model="optionItem.Selected"
                    class="choice"
                    :disabled="answerPaperState.IsSubmit"
                    @change="optionCheckChange(element)"
                  >
                    <div class="choice_inner">
                      <span class="choice_index">{{
                        getOptionIndex(
                          answerPaper.OptionSerialNumberType,
                          optionIndex
                        )
                      }}</span>
                      <div
                        class="choice_content"
                        v-html="optionItem.Content"
                      ></div>
                    </div>
                  </el-checkbox>
                </div>
              </div>

              <div v-if="element.QuestionType === 5">
                <el-input
                  type="textarea"
                  :rows="element.TextHeight"
                  :minlength="element.MinWordNum"
                  :maxlength="element.MaxWordNum"
                  :style="[
                    {
                      width:
                        element.TextWidth == 0
                          ? '100%'
                          : element.TextWidth + 'px'
                    }
                  ]"
                  v-model="element.AnswerElementAnswer"
                  :disabled="answerPaperState.IsSubmit"
                  @focus="qaFocus(element)"
                  :resize="element.TextHeight === 1 ? 'none' : 'vertical'"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="wj_body" v-if="answerPaper.State !== 1">
          <el-empty :description="answerPaper.StrState"></el-empty>
        </div>
      </el-col>
    </el-row>
    <el-row class="wj_footer">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="wj_footer_box" style="justify-content: center">
          <div class="hidden-xs-only">
            北京鹏宇成软件技术有限公司 提供技术支持
          </div>
          <div>
            <el-button
              type="primary"
              style="width: 100px; letter-spacing: 10px; text-indent: 10px"
              @click="saveAnswerPaper()"
              v-if="
                answerPaper.State === 1 &&
                !answerPaper.IsSubmit &&
                (answerPaper.TimeState === 0 || answerPaper.TimeState === 2) &&
                false
              "
            >
              保存
            </el-button>
            <el-button
              type="primary"
              style="width: 80px; letter-spacing: 5px; text-indent: 5px"
              @click="backList()"
              plain
            >
              返回
            </el-button>
            <el-button
              type="primary"
              style="width: 80px; letter-spacing: 5px; text-indent: 5px"
              @click="submitAnswerPaper()"
              v-if="
                answerPaper.State === 1 &&
                !answerPaper.IsSubmit &&
                (answerPaper.TimeState === 0 || answerPaper.TimeState === 2)
              "
            >
              提交
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import voteManageApi from '../../api/vote/voteManage'
import answerPaperApi from '../../api/wj/answerPaper'
import FlipDown from '@/components/FlipDown.vue'
const wx = require('weixin-js-sdk')
export default {
  components: {
    FlipDown
  },
  data () {
    return {
      voteInfo: {},
      answerPaperState: {
        AnswerPaperId: null,
        IsSubmit: true
      },
      answerPaper: {},
      answerPaperForm: {},
      tempElementItems: [],
      noAnswerList: []
    }
  },
  methods: {
    backList: function () {
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        // wx.miniProgram.navigateTo({
        //   url: '/pages/voting/votingList/votingList?meetingId=' + this.$route.params.mid
        // })
        wx.miniProgram.navigateBack()
      }
    },
    voteWJLogin () {
      const _this = this
      var date = new Date()
      const saveParam = {
        token: _this.$route.params.token,
        token_type: 'bearer',
        refresh_token: null,
        expires_in: 43199,
        issued: Date(),
        expires: date.setDate(date.getDate() + 1),
        role: 'user',
        rememberClient: false
      }
      _this.$store.commit('ADD_ACCOUNT', saveParam)
      _this.getVoteInfo()
    },
    getVoteInfo: function () {
      const _this = this
      _this.openLoading()
      if (_this.$route.params.vid !== '0') {
        voteManageApi.getVoteDetail({
          voteId: _this.$route.params.vid
        }).then(data => {
          _this.voteInfo = data
          _this.getAnswerPaperState()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      } else {
        _this.voteInfo.Status = 0
        _this.openLoading().close()
      }
    },
    getAnswerPaperState: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getAnswerPaperState({
        questionnaireId: _this.voteInfo.QuestionnaireId
      }).then(data => {
        _this.answerPaperState = data
        _this.getAnswerPaper()
        // if (_this.answerPaperState.AnswerPaperId) {
        //   _this.getAnswerPaper()
        // } else {
        //   _this.answerPaper = { State: -1, StrState: '暂无数据，禁止填报' }
        //   _this.openLoading().close()
        //   if (typeof wx !== 'undefined' && wx.miniProgram) {
        //     // wx.miniProgram.navigateTo({
        //     //   url: '/pages/voting/votingList/votingList?meetingId=' + this.$route.params.mid
        //     // })
        //     wx.miniProgram.navigateBack()
        //   }
        // }
      }).catch(err => {
        _this.answerPaper = { State: -1, StrState: '暂无数据，禁止填报' }
        _this.openLoading().close()
        return err
      })
    },
    getAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getCurrentUserAnswerPaper({
        QuestionnaireId: _this.voteInfo.QuestionnaireId,
        AnswerPaperId: _this.answerPaperState.AnswerPaperId
      }).then(data => {
        _this.answerPaper = data
        _this.answerPaper.EndTime = new Date(this.$moment(_this.answerPaper.EndTime).format('yyyy-MM-DD HH:mm'))
        _this.answerPaper.CurrentTime = new Date(this.$moment(_this.answerPaper.CurrentTime).format('yyyy-MM-DD HH:mm'))

        _this.openLoading().close()
      }).catch(err => {
        _this.answerPaper = { State: -1, StrState: '暂无数据，禁止填报' }
        _this.openLoading().close()
        if (typeof wx !== 'undefined' && wx.miniProgram) {
          //   wx.miniProgram.navigateTo({
          //     url: '/pages/voting/votingList/votingList?meetingId=' + this.$route.params.mid
          //   })
          wx.miniProgram.navigateBack()
        }
        return err
      })
    },
    getOptionIndex: function (optionSerialNumberType, optionIndex) {
      if (optionSerialNumberType === 2) {
        return String.fromCharCode(65 + optionIndex) + '、'
      } else if (optionSerialNumberType === 3) {
        return String.fromCharCode(65 + optionIndex).toLowerCase() + '、'
      } else {
        // return optionIndex + 1 + '、'
        return ''
      }
    },
    getBlankBody1: function (element) {
      //   const questionStem = ''
      let questionStem = JSON.parse(JSON.stringify(element.QuestionStem))
      questionStem = questionStem.replace(/<p>/g, '')
      questionStem = questionStem.replace(/<\/p>/g, '')
      const stemArray = questionStem.split('___')

      const blankItems = []
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          blankItems.push(item)
        }
      })
      return blankItems
    },
    getBlankBody: function (element, elementIndex) {
      const _this = this
      let questionStem = ''
      const stemArray = element.QuestionStem.split('___')

      let optionIndex = 0
      stemArray.forEach(function (item, index) {
        if (item !== '') {
          questionStem = questionStem + item
          if (index < stemArray.length - 1) {
            let blankItemTextWidth = element.OptionItems[optionIndex].TextWidth + 'px'
            if (element.OptionItems[optionIndex].TextWidth === 0) {
              blankItemTextWidth = '100%'
            }
            const blankItemAnswer = element.OptionItems[optionIndex].Answer
            if (_this.answerPaperState.IsSubmit) {
              questionStem = questionStem + '<input type="text" id="' + element.AnswerPaperElementId.toLowerCase() + '_' + element.OptionItems[optionIndex].AnswerPaperOptionId.toLowerCase() + '" class="blankInput" style="width:' + blankItemTextWidth + '" value="' + blankItemAnswer + '" maxlength="' + element.OptionItems[optionIndex].MaxWordNum + '" minlength="' + element.OptionItems[optionIndex].MinWordNum + '" disabled />'
            } else {
              questionStem = questionStem + '<input type="text" id="' + element.AnswerPaperElementId.toLowerCase() + '_' + element.OptionItems[optionIndex].AnswerPaperOptionId.toLowerCase() + '" class="blankInput" style="width:' + blankItemTextWidth + '" value="' + blankItemAnswer + '" maxlength="' + element.OptionItems[optionIndex].MaxWordNum + '" minlength="' + element.OptionItems[optionIndex].MinWordNum + '"  />'
            }
            optionIndex++
          }
        }
      })
      return questionStem
    },
    saveAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      _this.validateAnswerPaperForm('all_save')
      _this.setAnswerPaperForm('all_save')
      _this.editAnswerPaper('all_save')
    },
    submitAnswerPaper: function () {
      const _this = this
      _this.validateAnswerPaperForm('submit')
      if (_this.noAnswerList.length > 0) {
        _this.$confirm('有未回答的问题，请检查确认是否提交？', '提示', {
          confirmButtonText: '确定提交',
          cancelButtonText: '继续填写',
          customClass: 'wj_message_box',
          type: 'warning'
        }).then(() => {
          _this.openLoading()
          _this.setAnswerPaperForm('submit')
          _this.editAnswerPaper('submit')
        }).catch((err) => {
          return err
        })
      } else {
        _this.$confirm('确定提交吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'wj_message_box'
        }).then(() => {
          _this.openLoading()
          _this.setAnswerPaperForm('submit')
          _this.editAnswerPaper('submit')
        }).catch((err) => {
          return err
        })
      }
    },
    editAnswerPaper: function (action) {
      const _this = this
      console.log(_this.answerPaperForm)
      answerPaperApi.saveAnswerPaper(_this.answerPaperForm).then(data => {
        if (action === 'submit') {
          _this.getAnswerPaperState()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '投票成功！',
            customClass: 'custom_message'
          })
          _this.openLoading().close()
          //   this.$alert('投票成功', '', {
          //     confirmButtonText: '返回列表',
          //     type: 'success',
          //     center: true,
          //     callback: action => {
          //       if (typeof wx !== 'undefined' && wx.miniProgram) {
          //         wx.miniProgram.navigateBack()
          //       }
          //     }
          //   })
        }
        if (action === 'all_save') {
          _this.getAnswerPaperState()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功！',
            customClass: 'custom_message'
          })
        }
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    validateAnswerPaperForm: function (action) {
      const _this = this
      _this.openLoading()
      _this.noAnswerList = []
      _this.tempElementItems = []
      _this.answerPaper.ElementItems.forEach(function (elementItem, elementItemIndex) {
        if (elementItem.ElementType === 2) {
          const tempElementItem = {}
          switch (elementItem.QuestionType) {
            case 1: {
              if (!elementItem.SelectOptionId && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                let optionSelected = false
                if (elementItem.SelectOptionId) {
                  if (optionItem.AnswerPaperOptionId.toLowerCase() === elementItem.SelectOptionId.toLowerCase()) {
                    optionSelected = true
                  }
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: '',
                    Selected: optionSelected
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              break
            }
            case 2: {
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              let selectedNum = 0
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                let optionSelected = false
                if (optionItem.Selected) {
                  optionSelected = true
                  selectedNum++
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: '',
                    Selected: optionSelected
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              if (selectedNum === 0 && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              break
            }
            case 3:
              if (!elementItem.SelectOptionId && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                let optionSelected = false
                if (elementItem.SelectOptionId) {
                  if (optionItem.AnswerPaperOptionId.toLowerCase() === elementItem.SelectOptionId.toLowerCase()) {
                    optionSelected = true
                  }
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: '',
                    Selected: optionSelected
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              break
            case 4: {
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              tempElementItem.OptionItems = []
              let emptyNum = 0
              elementItem.OptionItems.forEach(function (optionItem, optionItemIndex) {
                const optionItemInput = document.getElementById(elementItem.AnswerPaperElementId + '_' + optionItem.AnswerPaperOptionId)
                if (!optionItemInput.value) {
                  emptyNum++
                }
                tempElementItem.OptionItems.push(
                  {
                    AnswerPaperOptionId: optionItem.AnswerPaperOptionId,
                    Answer: optionItemInput.value ? optionItemInput.value : ''
                  }
                )
              })
              _this.tempElementItems.push(tempElementItem)
              if (emptyNum > 0 && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              break
            }
            case 5: {
              if (!elementItem.AnswerElementAnswer && action === 'submit') {
                _this.$set(elementItem, 'NoAnswer', true)
                _this.noAnswerList.push(elementItem.AnswerPaperOptionId)
              }
              tempElementItem.AnswerPaperElementId = elementItem.AnswerPaperElementId
              if (elementItem.AnswerElementAnswer) {
                tempElementItem.Answer = elementItem.AnswerElementAnswer
              }
              _this.tempElementItems.push(tempElementItem)
              break
            }
          }
        }
      })
      _this.openLoading().close()
    },
    setAnswerPaperForm: function (action) {
      const _this = this
      _this.answerPaperForm = {}
      _this.answerPaperForm.AnswerPaperId = _this.answerPaper.AnswerPaperId
      _this.answerPaperForm.QuestionnaireId = _this.answerPaper.QuestionnaireId
      _this.answerPaperForm.Action = action
      _this.answerPaperForm.ElementItems = _this.tempElementItems
    },
    qaFocus: function (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    blankFocus (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    optionRadioChange: function (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    optionCheckChange: function (element) {
      const _this = this
      _this.$set(element, 'NoAnswer', false)
    },
    timeOut: function () {
      const _this = this
      _this.$confirm('已过答卷时限，是否提交问卷！', '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: false
      }).then(() => {
        _this.validateAnswerPaperForm('submit')
        _this.openLoading()
        _this.setAnswerPaperForm('submit')
        _this.editAnswerPaper('submit')
      }).catch(() => {
        _this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
      })
    }
  },
  created () {
    this.voteWJLogin()
  }
}
</script>

<style lang="less">
@import '../../assets/css/wj.css';
.wj_body {
  background-color: #eff3fa;
}
.wj_element_box {
  padding: 3px 0px 0px 0px;
}
.wj_element_title_all .show_index {
  flex-shrink: 0;
  margin: 0px 5px 0px 0px;
  min-height: 36px;
}
.wj_element_title_all .wj_element_title .blankInput {
  border-style: solid;
  border-width: 1px;
  border-color: #fff #fff #cdcdcd #fff;
  margin: 0px 3px;
  font-size: 16px;
  height: 32px;
  line-height: 32px;
}
.wj_element_title_all .wj_element_title .blankInput:focus {
  border-style: solid;
  border-width: 1px;
  /* border-color: #8c8c8c; */
  border-color: #409eff;
  outline-style: none;
}
.wj_element_title_all .wj_element_title p {
  line-height: 36px;
}
</style>
